import React from "react";
import MarketplaceLiveStockSingleIndex from "../components/marketplaceLiveStockSingle";
import Footer from "../components/commonComponents/footer";
import Navbar from '../components/commonComponents/Navbar/Navbar';
import { useSelector } from "react-redux";
import PageLoader from "../common/pageLoader";

export default function MarketplaceLiveStockSingle() {

    const { pageLoader } = useSelector(state => state.commonReducer);

    return (
        <div className={`${pageLoader && "body-overflow-hide"}`}>
            {/* <TopNavbar /> */}
            {pageLoader &&
                <PageLoader />
            }
            <Navbar />
            <MarketplaceLiveStockSingleIndex />
            <Footer />
        </div>
    )
}